/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationMessage } from '../../models/notification-message';

export interface ApiAgencyinquirySignUpRequestPost$Params {
  'api-version'?: string;
      body?: {
'files'?: Array<Blob>;
'inquiryContact.firstName': string;
'inquiryContact.lastName': string;
'inquiryContact.position'?: string;
'inquiryContact.email': string;
'inquiryContact.phoneNumber': string;
'inquiryAgency.name': string;
'inquiryAgency.address': string;
'inquiryAgency.postalCode': string;
'inquiryAgency.city': string;
'inquiryAgency.province': string;
'inquiryAgency.website'?: string;
'inquiryAgency.email': string;
'inquiryAgency.phoneNumber': string;
'missionStatement': string;
'programDescription': string;
'interviewWillingness': boolean;
'commitmentDescription': string;
'partnershipWillingness': boolean;
'evaluationReport': string;
'allowCheckIns': boolean;
'accountabilityDocumentation': string;
'accountabilityPrevention': string;
'staffTraining': string;
'trainingWillingness': boolean;
'comments'?: string;
'signature': string;
'referenceNumber': number;
}
}

export function apiAgencyinquirySignUpRequestPost(http: HttpClient, rootUrl: string, params?: ApiAgencyinquirySignUpRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiAgencyinquirySignUpRequestPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiAgencyinquirySignUpRequestPost.PATH = '/api/agencyinquiry/sign-up-request';
